module.exports = __webpack_public_path__ + "img/VA_logo.0f3d6047.png";